const statuses = [
  {
    name: "Yangi buyurtma",
    value: "NEW",
    color: "primary",
    bg: "#0088cc",
  },
  {
    name: "Qabul qilindi",
    value: "APPROVED",
    color: "success",
    bg: "#00c49f",
  },
  {
    name: "Yetkazilmoqda",
    value: "IN_PROGRESS",
    color: "warning",
    bg: "#ffc658",
  },
  {
    name: "Yetkazildi",
    value: "COMPLETED",
    color: "info",
    bg: "#4dd0e1",
  },
  {
    name: "Bekor qilindi",
    value: "CANCELED",
    color: "error",
    bg: "#f44336",
  },
];

export default statuses;
